import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-alternatives-chainalysis',
  imports: [MatIcon, RouterLink, RelatedPagesComponent],
  templateUrl: './chainalysis.component.html',
  styleUrl: './chainalysis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlternativesChainalysisComponent {
  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-compliance-software',
      anchor: "AML compliance software",
      text: "What AMLOfficer is in its own right: four AML data providers behind one interface, for a small compliance team.",
    },
    {
      link: '/transaction-monitoring',
      anchor: "Crypto transaction monitoring",
      text: "The monitoring side in detail - what is watched, what raises an alert and where the alert arrives.",
    },
  ];

  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => {
    if (!isPlatformBrowser(this._platformId)) {
      return 'https://app.amlofficer.org/register-corporate-account';
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query
      ? `https://app.amlofficer.org/register-corporate-account?${query}`
      : `https://app.amlofficer.org/register-corporate-account`;
  });
}
